module.exports = __webpack_public_path__ + "media/images/pages/bg_area_01-704fde83b3c4d47caefecf30ddb122f0.png";